<script>
import RequestAgentKitDialog from "../../common/requestAgentKitDialog.vue";
import {redirectToAgentLogin} from "../../../helpers/routerHelper";
import {STATES} from "../../../helpers/constantsHelper";
import {mapActions} from "vuex";
import {regexPatterns} from "../../../utils/utils";

export default {
  name: "agentRegistrationSection1-Interim",
  data() {
    return {
      loading: false,
      requestAgentDialogVisible: false,
      requestAgentForm: {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      },
      rules: {
        firstName: {
          required: true,
          message: "Please enter your first name",
          trigger: "blur"
        },
        lastName: {
          required: true,
          message: "Please enter your last name",
          trigger: "blur"
        },
        companyName: {
          required: true,
          message: "Please enter your company name",
          trigger: "blur"
        },
        state: {
          required: true,
          message: "Please select your state",
          trigger: ["blur"]
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
        phoneNumber: {
          required: true,
          message: "Please enter your phone number",
          trigger: "blur",
          pattern: regexPatterns.phoneNumber
        },
        // message: {
        //   required: true,
        //   message: "Please enter your message",
        //   trigger: "blur"
        // }
      }
    };
  },
  methods: {
    ...mapActions("request", ["sendRequestAgentKitEmail"]),
    redirectToAgentLogin,
    requestAgentKit() {
      this.requestAgentDialogVisible = true;
    },
    STATES() {
      return STATES
    },
    validateField(field) {
      this.$refs.requestAgentForm.validateField(field);
    },
    onSubmit(formName) {
      if (this.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          this.sendRequestAgentKitEmail({
            params: {
              data: {
                firstName: this.requestAgentForm.firstName,
                lastName: this.requestAgentForm.lastName,
                companyName: this.requestAgentForm.companyName,
                state: this.requestAgentForm.state,
                email: this.requestAgentForm.email,
                phoneNumber: this.requestAgentForm.phoneNumber,
                message: this.requestAgentForm.message ? this.requestAgentForm.message : "N/A",
              },
            },
            callback: this.agentKitEmailCallback
          });
        } else {
          return false;
        }
      });
    },
    agentKitEmailCallback(res) {
      this.loading = false;
      if (res.data.code == 0) {
        this.$notify({
          title: 'Success',
          message: 'Agent kit request sent successfully',
          type: 'success',
          customClass: 'my-custom-notify',
          duration: 6000,
        });
        this.clearRequestAgentForm();
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
    clearRequestAgentForm() {
      this.requestAgentForm = {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      };
    }
  },
  components: {RequestAgentKitDialog}
}
</script>

<template>
  <div class="page-outer-wrapper">
    <el-row class="main-content font-family">
      <el-col :span="24"
                 class="left-content">
        <el-row :gutter="10">
          <el-col :span="24" style="text-align: center; line-height: 2">
            <span class="title">LIST YOUR DEVELOPMENTS ON UNIFI TODAY!</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="font-size: 24px; margin-top: 20px">
          <el-col :span="2">
            <i class="el-icon-circle-check"></i>
          </el-col>
          <el-col :span="22">
            <span>Present your developments to an engaged audience</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="font-size: 24px; margin-top: 10px">
          <el-col :span="2">
            <i class="el-icon-circle-check"></i>
          </el-col>
          <el-col :span="22">
            <span>Access our network of channel partners with exclusive clientele</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="font-size: 24px; margin-top: 10px">
          <el-col :span="2">
            <i class="el-icon-circle-check"></i>
          </el-col>
          <el-col :span="22">
            <span>Higher success, faster sales results</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="font-size: 24px; margin-top: 10px">
          <el-col :span="2">
            <i class="el-icon-circle-check"></i>
          </el-col>
          <el-col :span="22">
            <span>Support and assistance available to list your project</span>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24" class="content-wrapper">
            <el-card>
              <el-row>
                <el-col :span="24" style="display: flex; justify-content: center; padding: 10px 0 20px 0;">
                  <span style="font-weight: 600; font-size: 18px">Request to Join UNIFI Property</span>
                </el-col>
              </el-row>
              <el-form
                ref="requestAgentForm"
                :model="requestAgentForm"
                :rules="rules"
                label-position="top"
                label-width="100px"
                @submit.native.prevent
                style="font-family: DINosaur-a, sans-serif;">
                <el-row>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="First Name" prop="firstName">
                          <el-input
                            v-model="requestAgentForm.firstName"
                            maxlength="50"
                            placeholder="Your first name"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Last Name" prop="lastName">
                          <el-input
                            v-model="requestAgentForm.lastName"
                            maxlength="100"
                            placeholder="Your last name"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Company" prop="companyName">
                          <el-input
                            v-model="requestAgentForm.companyName"
                            maxlength="100"
                            placeholder="Agency/Developer name"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Location" prop="state">
                          <el-select v-model="requestAgentForm.state" @change="validateField('state')" clearable filterable placeholder="Select a state" style="width: 100%">
                            <el-option
                              v-for="item in STATES()"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Email" prop="email">
                          <el-input
                            v-model="requestAgentForm.email"
                            maxlength="100"
                            placeholder="Your email"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Phone Number" prop="phoneNumber">
                          <el-input
                            v-model="requestAgentForm.phoneNumber"
                            maxlength="20"
                            placeholder="Your phone number"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="Message" prop="message">
                          <el-input
                            type="textarea"
                            v-model="requestAgentForm.message"
                            maxlength="1000"
                            show-word-limit
                            placeholder="Message"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <el-form-item style="text-align:center">
                          <el-button class="join-btn" @click="onSubmit('requestAgentForm')">
                            Contact Us
                            <i v-if="loading" class="el-icon-loading"></i>
                          </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24" style="display: flex; justify-content: center; margin-top: 20px">
            <span style="font-size: 28px; display: flex; text-align: center">Agent & Developer Login</span>
          </el-col>
          <el-col :span="24" style="display: flex; align-items: center; margin-top: 20px">
            <el-button
              type="primary"
              size="large"
              class="sign-in-btn"
              @click="redirectToAgentLogin"
            >
              Login
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="padding: 10px 0 20px 0">
        <div class="image-container">
          <img
            src="./../../../assets/agent-section-2-page-background.png"
            alt="UNIFI Property Platform Preview"
            class="feature-image"
          >
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-row class="step-row">
          <el-col :span="24" class="step-title"><span>Step 1</span></el-col>
          <el-col :span="24" class="step-desc"><span>Create account</span></el-col>
        </el-row>
        <el-row class="step-row">
          <el-col :span="24" class="step-title"><span>Step 2</span></el-col>
          <el-col :span="24" class="step-desc"><span>Upload project information to UNIFI</span></el-col>
        </el-row>
        <el-row class="step-row">
          <el-col :span="24" class="step-title"><span>Step 3</span></el-col>
          <el-col :span="24" class="step-desc"><span>Publish the project live to our channel partners</span></el-col>
        </el-row>
        <el-row class="step-row">
          <el-col :span="24" class="step-title"><span>Step 4</span></el-col>
          <el-col :span="24" class="step-desc"><span>Receive sales for your project</span></el-col>
        </el-row>
        <el-row class="step-row">
          <el-col :span="24" class="step-title"><span>Step 5</span></el-col>
          <el-col :span="24" class="step-desc"><span style="font-weight: bold">Repeat!</span></el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.main-content {
  display: flex;
  min-height: 60%;
}

.left-content {
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
}
.content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
}

.title {
  color: #003333;
  font-size: 40px;
  line-height: 1;
  font-weight: 700;
  margin-bottom: 20px;

}

.subtitle {
  color: #003333;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 30px;

}

.description {
  color: #003333;
  font-size: 14px;
  margin-bottom: 40px;
  line-height: 1.5;
}

.join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 25px;
  padding: 10px 0;
  height: max-content;
  margin-top: 10px;
  font: 500 20px DINosaur-a, sans-serif;
  color: #ffffff;
}

.sign-in-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  color: #ffffff;
  border-radius: 25px;
  padding: 5px 0;
  height: max-content;
  outline: 2px solid #003333;
  outline-offset: 3px;
  font: 500 20px DINosaur-a, sans-serif;
}

.right-content {
  position: relative;
}

.image-wrapper{
  width: 90%;

}
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-card /deep/ .el-card__body {
  padding: 10px !important;
}

.el-form--label-top /deep/ .el-form-item__label {
  padding: 0 !important;
  line-height: normal !important;
}

.el-divider__text {
  padding: 0 10px !important;
}

.font-family {
  font-family: "DINosaur-a", sans-serif;
}

.step-row {
  font-size: 20px;
  letter-spacing: 2px;
  word-spacing: 2px;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}

.step-title {
  color: #003333;
  background-color: #cccccc;
  border-top: #003333 solid 1px;
  border-right: #003333 solid 1px;
  border-left: #003333 solid 1px;
  padding: 5px 0;
  width: 100%;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
}

.step-desc {
  color: #ffffff;
  background-color: #003333;
  border-bottom: #003333 solid 1px;
  border-right: #003333 solid 1px;
  border-left: #003333 solid 1px;
  border-radius: 0 0 10px 10px;
  padding: 5px 0 10px 0;
  display: flex;
  justify-content: center;
  text-align: center;
}

.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 500px;
  border-radius: 10px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  .left-content {
    padding: 30px;
  }
  .right-content {
    min-height: 300px;
    display: flex;
    justify-content: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationSection1-Interim.vue